import { useFormikContext } from 'formik';
import { ServiceCategory } from '@prisma/client';
import { CreateAptValues } from '../../utils/form/appointmentForm';
import { getCalendarTimezone } from '../../helpers/appointments';
import useUser from '../global/useUser';

// Any form whose values carry these keys can render a calendar input
export type CalendarFormValues = Pick<
  CreateAptValues,
  'employeeId' | 'serviceId' | 'businessTripId'
>;

/**
 * The props every calendar input derives from Formik and the signed-in user.
 * Shared so the picker behaves the same wherever it is rendered.
 */
export default function useCalendarFormFields(): {
  employeeId: string;
  serviceCategory: ServiceCategory | undefined;
  timezone: string;
} {
  const { user: loadedUser } = useUser();
  const { values } = useFormikContext<CalendarFormValues>();

  return {
    employeeId: values.employeeId || '',
    // 0 or null/undefined is for tattoo
    serviceCategory: +(values.serviceId || 0) ? undefined : 'TATTOO',
    timezone: getCalendarTimezone(
      loadedUser ?? undefined,
      values.businessTripId,
    ),
  };
}
